import getFormData from '@/util/form-data';
import clone from 'just-clone';
import httpClient from '@/api/http-client';

const endpoint = 'api/system-settings';

const systemSettings = {
  create: (sysSettings) => {
    const settings = clone(sysSettings);
    const formData = getFormData(settings);
    return httpClient.post(`${endpoint}`, formData);
  },

  // there is only one id (id: 1)
  getSettings: () => httpClient.get(`${endpoint}/1`),
};

export default systemSettings;
